var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import React, { createContext, useContext, useReducer } from "react";
import { MeterGradients } from "../";
import { EmphasisEnum, EmphasisInverseEnum, ThemeConstantEnum } from "../../enums";
var white = function (opacity) {
    if (opacity === void 0) { opacity = 1; }
    return "rgba(249,249,249,".concat(opacity, ")");
};
var black = function (opacity) {
    if (opacity === void 0) { opacity = 1; }
    return "rgba(1,1,1,".concat(opacity, ")");
};
var transparent = function (opacity) {
    if (opacity === void 0) { opacity = 0; }
    return "rgba(255,255,255,".concat(opacity, ")");
};
export var themeData = {
    currentTheme: "dark",
    themes: {
        light: (_a = {
                white: white,
                black: black
            },
            _a[ThemeConstantEnum.transparent] = transparent,
            _a[EmphasisEnum.primary] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(32,105,255,".concat(opacity, ")");
            },
            _a[EmphasisEnum.secondary] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(255,142,42,".concat(opacity, ")");
            },
            _a[EmphasisEnum.tertiary] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(195,3,220,".concat(opacity, ")");
            },
            _a[EmphasisEnum.grey] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(140,140,140,".concat(opacity, ")");
            },
            _a[EmphasisInverseEnum.primary] = white,
            _a[EmphasisInverseEnum.secondary] = white,
            _a[EmphasisInverseEnum.tertiary] = white,
            _a[EmphasisInverseEnum.grey] = white,
            //status colors
            _a[EmphasisEnum.success] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(40,210,40,".concat(opacity, ")");
            },
            _a[EmphasisEnum.warning] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(255,180,0,".concat(opacity, ")");
            },
            _a[EmphasisEnum.danger] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(225,55,55,".concat(opacity, ")");
            },
            _a[EmphasisInverseEnum.success] = white,
            _a[EmphasisInverseEnum.warning] = black,
            _a[EmphasisInverseEnum.danger] = white,
            // background colors
            _a.bgApp = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(255,255,255,".concat(opacity, ")");
            },
            _a.bgNav = function (opacity) {
                if (opacity === void 0) { opacity = 0.8; }
                return "rgba(0,0,0,".concat(opacity, ")");
            },
            _a.bgContent = white,
            _a.bgContent2 = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(240,240,240,".concat(opacity, ")");
            },
            _a.bgHeader = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(11,206,37,".concat(opacity, ")");
            },
            _a.bgInput = white,
            _a.bgDisabled = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(119,119,119,".concat(opacity, ")");
            },
            // border colors
            _a.borderApp = black,
            _a.borderNav = function (opacity) {
                if (opacity === void 0) { opacity = 0.2; }
                return white(opacity);
            },
            _a.borderContent = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(20,20,20,".concat(opacity, ")");
            },
            _a.borderHeader = black,
            _a.borderInput = function (opacity) {
                if (opacity === void 0) { opacity = 0.8; }
                return "rgba(215,215,215,".concat(opacity, ")");
            },
            // font + svg colors
            _a.colorApp = black,
            _a.colorNav = white,
            _a.colorContent = black,
            _a.colorHeader = white,
            _a.colorInput = black,
            _a.colorDisabled = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(47,47,47,".concat(opacity, ")");
            },
            _a.colorRequired = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(255,60,0,".concat(opacity, ")");
            },
            // box shadow
            _a.boxShadow = "0px 4px 8px rgba(0,0,0,.2)",
            _a.boxShadowInset = "inset 0px 0px 4px 1px rgba(179,179,179,1)",
            // font type
            _a.fontBase = '"Open Sans", sans-serif',
            _a.fontCode = "monospace",
            _a.colorScheme = "light",
            _a),
        dark: (_b = {
                white: white,
                black: black
            },
            _b[ThemeConstantEnum.transparent] = transparent,
            _b[EmphasisEnum.primary] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(32,105,255,".concat(opacity, ")");
            },
            _b[EmphasisEnum.secondary] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(129,210,214,".concat(opacity, ")");
            },
            _b[EmphasisEnum.tertiary] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(134,230,129,".concat(opacity, ")");
            },
            _b[EmphasisEnum.grey] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(140,140,140,".concat(opacity, ")");
            },
            _b[EmphasisInverseEnum.primary] = white,
            _b[EmphasisInverseEnum.secondary] = white,
            _b[EmphasisInverseEnum.tertiary] = white,
            _b[EmphasisInverseEnum.grey] = white,
            //status colors
            _b[EmphasisEnum.success] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(75,210,75,".concat(opacity, ")");
            },
            _b[EmphasisEnum.warning] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(255,235,0,".concat(opacity, ")");
            },
            _b[EmphasisEnum.danger] = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(225,55,55,".concat(opacity, ")");
            },
            _b[EmphasisInverseEnum.success] = white,
            _b[EmphasisInverseEnum.warning] = black,
            _b[EmphasisInverseEnum.danger] = white,
            // background colors
            _b.bgApp = black,
            _b.bgNav = function (opacity) {
                if (opacity === void 0) { opacity = 0.8; }
                return "rgba(0,0,0,".concat(opacity, ")");
            },
            _b.bgContent = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(21,21,21,".concat(opacity, ")");
            },
            _b.bgContent2 = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(0,0,0,".concat(opacity, ")");
            },
            _b.bgHeader = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(137,128,235,".concat(opacity, ")");
            },
            _b.bgInput = black,
            _b.bgDisabled = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(114,114,114,".concat(opacity, ")");
            },
            // border colors
            _b.borderApp = white,
            _b.borderNav = function (opacity) {
                if (opacity === void 0) { opacity = 0.2; }
                return white(opacity);
            },
            _b.borderContent = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(76,76,76,".concat(opacity, ")");
            },
            _b.borderHeader = white,
            _b.borderInput = function (opacity) {
                if (opacity === void 0) { opacity = 0.4; }
                return "rgba(255,255,255,".concat(opacity, ")");
            },
            // box shadow
            _b.boxShadow = "0 4px 8px rgba(255,255,255,.1)",
            _b.boxShadowInset = "inset 0px 0px 4px 1px rgba(76,76,76,1)",
            // font + svg colors
            _b.colorApp = white,
            _b.colorNav = white,
            _b.colorContent = white,
            _b.colorHeader = white,
            _b.colorInput = white,
            _b.colorDisabled = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(175,175,175,".concat(opacity, ")");
            },
            _b.colorRequired = function (opacity) {
                if (opacity === void 0) { opacity = 1; }
                return "rgba(255,60,0,".concat(opacity, ")");
            },
            // font type
            _b.fontBase = '"Open Sans", sans-serif',
            _b.fontCode = "monospace",
            _b.colorScheme = "dark",
            _b),
    },
};
var UIThemeContext = createContext([themeData, function () { return null; }]);
UIThemeContext.displayName = "UIThemeProvider";
export var useUIThemeContext = function () {
    return useContext(UIThemeContext);
};
var dispatchFn = function (state, action) {
    if (Array.isArray(action)) {
        return action.reduce(function (acc, curr) { return dispatchFnSwitch(acc, curr); }, __assign({}, state));
    }
    return dispatchFnSwitch(state, action);
};
var dispatchFnSwitch = function (state, action) {
    switch (action.type) {
        case "SET_THEME": {
            return __assign(__assign({}, state), { currentTheme: action.payload });
        }
        default:
            return state;
    }
};
export var UIThemeProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(dispatchFn, themeData), state = _b[0], dispatch = _b[1];
    return (React.createElement(UIThemeContext.Provider, { value: [state, dispatch] },
        React.createElement(MeterGradients, null),
        children));
};
